import { IllegalArgumentException } from '../../../../../../models/errors/general.errors';
import WorkspaceAssetsUrls from './workspace-assets.urls';
import { IWSContext } from '../../../../../../models/workspace/workspace-model';

class WorkspaceAssetsDetailsUrls {
    public getUpdateFileNamePUTUrl(wsContext: IWSContext, assetId: string) {
        const baseUrl = this.getBasedAssetDetailsPath(wsContext, assetId);
        return baseUrl + '/file';
    }
    private getBasedAssetDetailsPath(wsContext: IWSContext, assetId: string) {
        if (!assetId) {
            throw new IllegalArgumentException(`Asset id is null! can't get url`);
        }

        const baseUrl = WorkspaceAssetsUrls.getWorkspaceAssetsUrl(wsContext);
        return `${baseUrl}/${assetId}`;
    }
}

export default new WorkspaceAssetsDetailsUrls();
